import { Box, CircularProgress } from '@mui/material';

interface LoadingIndicatorProps {
  size?: 'small' | 'medium' | 'large';
  fullHeight?: boolean;
}

const SIZES = {
  small: 20,
  medium: 24,
  large: 40,
};

/**
 * Consistent loading indicator with standardized sizes
 * - small: 20px (inline use)
 * - medium: 24px (default)
 * - large: 40px (full-page loading)
 */
export const LoadingIndicator = ({
  size = 'medium',
  fullHeight = false,
}: LoadingIndicatorProps) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      p={fullHeight ? 4 : 2}
      height={fullHeight ? '100%' : 'auto'}
    >
      <CircularProgress size={SIZES[size]} />
    </Box>
  );
};
